const indianStatesAndUTs = [
    'Andaman and Nicobar Islands',
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chandigarh',
    'Chhattisgarh',
    'Dadra and Nagar Haveli',
    'Daman and Diu',
    'New Delhi',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jammu and Kashmir',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Lakshadweep',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Puducherry',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Others',
  ];
  
  const statusOptions = [
    'Cured',
    'Lapsed due to Cure',
    'Lapsed due to Money Issue',
    'Lapsed due to no Result',
    'Only one Timers',
    'Improvement',
    'New',
    'Regular',
    'Intermittent',
    'Others',
  ];
  
  // Canonical patient-status lists. The DropDown admin page can extend these per
  // clinic; these are the fallback so the selects are never empty.
  const treatmentStatusOptions = [
    'Cured',
    'Lapsed due to Cure',
    'Lapsed due to Money Issue',
    'Lapsed due to no Result',
    'Improvement',
    'Treatment',
  ];

  const visitStatusOptions = [
    'New',
    'Only one Timers',
    'Regular',
    'Intermittent Patient',
    'Active Patient',
    'Lost',
    'Renewal Case',
    'Lost Patient',
    'Lost Recovery',
  ];

  const educationLevels = [
    'Toddler',
    'Up to 5th',
    'Up to 10th',
    'Up to 12th',
    'Undergraduate',
    'Graduation',
    'Post Graduation',
    'Others',
  ];
  

  const PatientRefrenceList = [
  'Husband',
  'Wife',
  'Daughter',
  'Son',
  'Father',
  'Mother',
  'Family',
  'Extended Family',
  'Relatives',
  'Colleagues',
  'Aquenties',
  'Doctor',
  'Others',
  ]

  const RefrenceList = [
"Patient",
"Google",
"Facebook",
"Whatsapp",
"Clinic Board",
"Seminar",
"Practo",
"Doctor",
"Staff",
"Medical Stores",
"Venkates",
"Dr. Shital",
"Instagram",
"LinkedIn",
"Google My Business",
"Google Call",
"Google Message",
"Clinic Visit",
"Website",
"Website Form",
  ]

    const ailmentsList = ["Choose","Bone Ailments","Female Ailments","Mental ailments","Beauty Enhancement","Skin Ailments","Kidney Disorder","Respiratory Ailments","Lifestyle Disorders","Heart Ailments","Brain Ailments","Children Ailments","Digestive Disorder"]



  const religionOptions = [
    'Hindu',
    'Muslim',
    'Christian',
    'Sikh',
    'Buddhist',
    'Jain',
    'Parsi',
    'Jewish',
    'Other',
    'Prefer not to say',
  ];

  // Must stay in sync with the `therapy_types` enum in backend/Models/ConsultantModel.js
  const consultantTypes = [
    'nutrition',
    'counselling',
    'acupuncture',
    'acupressure',
    'ayurvedic',
    'neuropathy',
    'physiotherapy',
  ];

  export {statusOptions, treatmentStatusOptions, visitStatusOptions, educationLevels, indianStatesAndUTs, PatientRefrenceList, RefrenceList, ailmentsList, religionOptions, consultantTypes}